import { useMemo, useState } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { filterBySearch } from '../../lib/filterBySearch';
import { DataTable } from '../ui/DataTable';
import { Input } from '../ui/Input';
import page from '../../pages/Page.module.css';

export function PricingSearchableTable<T>({
  data,
  columns,
  searchKeys,
  searchLabel = 'Search',
  searchPlaceholder = 'Filter rows…',
  layout,
}: {
  data: T[];
  columns: ColumnDef<T, unknown>[];
  searchKeys: ReadonlyArray<keyof T | ((row: T) => unknown)>;
  searchLabel?: string;
  searchPlaceholder?: string;
  layout?: 'full' | 'content';
}) {
  const [search, setSearch] = useState('');
  const filtered = useMemo(() => filterBySearch(data, search, searchKeys), [data, search, searchKeys]);

  return (
    <>
      <div style={{ marginBottom: 'var(--space-md)', maxWidth: 400 }}>
        <Input
          label={searchLabel}
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      {filtered.length === 0 && data.length > 0 ? (
        <p className={page.muted}>No rows match your search.</p>
      ) : (
        <DataTable data={filtered} columns={columns} enableSorting layout={layout} />
      )}
    </>
  );
}
